import React from "react";

const CardBanner = ({
  tagline,
  title,
  description,
  bannerProducImage,
  buttonText,
  onButtonClick,
  backgroundImage,
}) => {
  return (
    <div
      className="bg-cover bg-center rounded-lg p-6 text-white font-sans relative w-full h-auto flex flex-col md:flex-row items-center md:items-start"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      {/* Text Section */}
      <div className="flex-1 text-center md:text-left mb-6 md:mb-0">
        <h3 className="text-white font-bold text-lg mb-2">{tagline}</h3>
        <h2 className="text-white font-extrabold text-3xl md:text-4xl mb-4">
          {title}
        </h2>
        <p className="text-white text-sm md:text-base mb-4">{description} cashfuse points</p>
        <button
          onClick={onButtonClick}
          className="bg-white text-red-500 font-semibold py-2 px-6 md:px-3 rounded shadow-md hover:bg-gray-200 transition duration-200"
        >
          {buttonText}
        </button>
      </div>

      {/* Image Section */}
      <div className=" flex justify-center items-center flex-shrink-0 w-full md:w-full xl:w-8/12 max-w-md h-auto">
        <img
          src={bannerProducImage}
          alt={title}
          className="w-[100px] md:w-[150px] xl:w-[200px] h-auto object-contain rounded-lg"
        />
      </div>
    </div>
  );
};

export default CardBanner;
